export const SET_CUSTOMER = 'SET_CUSTOMER'
export const NEWSLETTER_SUBSCRIBE = 'NEWSLETTER_SUBSCRIBE'
export const NEWSLETTER_UNSUBSCRIBE = 'NEWSLETTER_UNSUBSCRIBE'
export const SET_NEWSLETTER_SUBSCRIBED = 'SET_NEWSLETTER_SUBSCRIBED'
export const BACK_IN_STOCK_SUBSCRIBE = 'BACK_IN_STOCK_SUBSCRIBE'
export const BACK_IN_STOCK_UNSUBSCRIBE = 'BACK_IN_STOCK_UNSUBSCRIBE'
export const SET_WATCHING = 'SET_WATCHING'
